export const InformationalMessage1FormFunctions = {}

InformationalMessage1FormFunctions.manageRetries = (navigate, stage) => {

 //navigate(`/${stage}`)
}

InformationalMessage1FormFunctions.doNextStage = (obj) => {
  if (sessionStorage.getItem('token')) {
    //Configuración
    let config = {
      pathname: `/${obj.nextComponent}`,
      state: {
        stageName: obj.stageName,
        stageId: obj.stageId,
        stage: obj.stage,
        folioId: obj.folioId,
        actorId: obj.actorId
      }
    }
    //Objeto lleno
    obj.navigate(config)
  }
  else {
    alert("No se encontró usuario.")
  }
}